<script setup lang="ts">
/* Components */
import DeliveryPointFilters from '@/components/Delivery/DeliveryPointFilters.vue'
import DeliveryPointList from '@/components/Delivery/DeliveryPointList.vue'

/* Stores */
import { useDeliveryStore } from '@/store/delivery/delivery'

const props = defineProps({
  selectedPointId: {
    type: Number as PropType<Number | null>,
    required: true,
  },
})

const emit = defineEmits(['setSelectPoint'])

const setSelectPoint = (pointId: number | null) =>
  emit('setSelectPoint', pointId)

const deliveryStore = useDeliveryStore()

const { isDesktop } = useDevice()

const filteredPoints = computed(() => deliveryStore.filteredPoints)

const showPoints = computed(() => Boolean(filteredPoints.value.length))

const filteredTags = computed(() => deliveryStore.filteredTags)
</script>

<template>
  <div class="delivery__points">
    <delivery-point-filters
      v-if="isDesktop"
      :filtered-tags="filteredTags"
      :show-points="showPoints"
    />

    <delivery-point-list
      :points="filteredPoints"
      :selected-point-id="props.selectedPointId"
      @set-select-point="setSelectPoint"
    />
  </div>
</template>

<style lang="scss" scoped>
.delivery__points {
  min-width: 400px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 9px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: $scrollbar;
    border-radius: 10px;
  }

  @include media('<desktop-mini') {
    min-width: 100%;
  }
}
</style>
